import Switch from "@mui/material/Switch";
import React from "react";

interface BooleanFilterProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
}

export const BooleanFilter: React.FC<BooleanFilterProps> = ({
  value,
  onChange,
  label,
}) => {
  return (
    <div
      className='w-60 flex items-center text-black text-base font-medium my-[-8px]'
      data-testid='booleanFilter'
    >
      <Switch
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
        data-testid='booleanSwitch'
      />
      <span data-testid='booleanLabel'>{label}</span>
    </div>
  );
};
